<template>
  <div>
      <div class="group-rounded-box row-py-clear">
        <div class="row">
          <div class="col-12">
            <h3 class="mt-0">Price Adjustment</h3>
            <p class="mb-4">This premium will be applied across all spot offers, but will not be applied to contract offers</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2 col-sm-12">
              Premium (ppl)
          </div>
          <div class="col-4">
            <span class="d-block">
              <cleave 
                :class="{ 'border-t_red': error }" 
                v-model="premium" 
                :options="numeral" 
                class="text-right" 
                placeholder="Enter customer premium"
                @blur="setDecimalPoints()"
              ></cleave>
            </span>
            <span v-if='error' class="error-message d-block">{{error}}</span>
          </div>
        </div>

        <div class="modal-footer justify-content-center">
          <el-button class="btn btn-neutral" size="small" @click="emitClose">
            Close
          </el-button>
          <el-button class="btn btn-neutral" size="small" @click="emitBack">
            Back
          </el-button>
          <el-button class="btn btn-neutral" size="small" @click="emitNext" :disabled="tabIndex >= tabsLength">
            Next
          </el-button>
          <el-button class="btn btn-confirm" size="small" @click.prevent="save" :disabled="!unsavedChangesFound || error" :loading="saveBtnLoading">
            Save
          </el-button>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import {  editCustomerRelationship } from '@/api/relationships.js';

const MAX_PREMIUM = 9;
const MIN_PREMIUM = -9;
const PREMIUM_ERROR = 'Please enter a valid premium';

export default {
    data(){
    return {
      saveBtnLoading: false,
      premium: 0,
      initialState: null
    }
  },
  created(){
    this.premium = this.relationshipProp.premium;
    this.initialState = {
      premium: this.premium
    };
    this.setDecimalPoints();
  },
  props: {
    relationshipProp: {
      type: Object,
      default: () => {},
      required: true
    },
    tabsLength: {
      type: Number,
      default: 0,
      required: true
    },
    tabIndex: {
      type: Number,
      default: 0,
      required: true
    },
  },
  computed:{
    ...mapGetters('inputCheckers', ['numeral']),
    error:{
      get: function(){
        if(this.premium < MIN_PREMIUM || this.premium > MAX_PREMIUM)
          return PREMIUM_ERROR;
        return false;
      }
    },
    unsavedChangesFound: function(){
      const status = Number(this.premium) !== Number(this.initialState && this.initialState.premium);
      this.$emit('emit-tracked-changes', status);
      return status;
    }
  },
  watch: {
    unsavedChangesFound(){}
  },
  methods:{
    emitBack(){
      this.$emit('emit-back', this.tabIndex)
    },
    emitNext(){
      this.$emit('emit-next', this.tabIndex)
    },
    emitClose(){
      this.$emit('emit-close', this.tabIndex);
    },
    setDecimalPoints: function(){
      this.premium = Number(this.premium).toFixed(2)
    },
    save: async function() {
      const newPremium = Number(this.premium);
        const payload = {
          relationshipId: this.relationshipProp.relationshipId,
          buyerAccountId: this.relationshipProp.id,
          premium: newPremium
        }
        this.saveBtnLoading = true;
        await editCustomerRelationship(payload);
        this.saveBtnLoading = false;
        this.$emit("reloadRelationshipProp");
      },
  }
}
</script>
